@if (!loading && paciente) {
  <app-breadcrumb
    listado="/main/emergencias/destinatariosAsistencia/medica"
    etiquetaListado="Pacientes"
    [titulo]="nombre"
  ></app-breadcrumb>

  <!-- Encabezado con la misma estética que las tarjetas del detalle -->
  <header class="encabezado">
    <div class="encabezado-avatar"><mat-icon>personal_injury</mat-icon></div>
    <div class="encabezado-texto">
      <h1>{{ nombre }}</h1>
      <!-- DNI, edad, sexo y obra social van una sola vez: en la tarjeta -->
      <div class="encabezado-chips">
        @if (cliente) {
          <span class="chip">
            <mat-icon>business</mat-icon>
            {{ cliente }}
          </span>
        }
      </div>
    </div>
    @if (puedeEditar) {
      <button
        irxBotonIcono
        class="encabezado-editar"
        (click)="editar()"
        tooltip="Editar paciente"
      >
        <mat-icon>edit</mat-icon>
      </button>
    }
  </header>

  <mat-tab-group
    [(selectedIndex)]="selectedTab"
    (selectedTabChange)="tabChanged($event)"
    class="tabs-detalle"
  >
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">info</mat-icon>
        <span>Info</span>
      </ng-template>
      <ng-template matTabContent>
        <div class="em-tarjetas">
          <app-dt-card titulo="Paciente" icono="personal_injury">
            <app-dt-datos>
              <app-dt-dato
                etiqueta="DNI"
                [valor]="paciente.dni"
                mono
                copiable
              />
              <app-dt-dato etiqueta="Edad" [valor]="edad" />
              <app-dt-dato etiqueta="Sexo" [valor]="sexo" />
              <app-dt-dato
                etiqueta="Obra social"
                [valor]="paciente.obraSocial"
              />
              <app-dt-dato etiqueta="Fecha de alta" [valor]="fechaAlta" />
            </app-dt-datos>
          </app-dt-card>

          <app-dt-card titulo="Contacto" icono="contacts">
            <app-dt-datos>
              <app-dt-dato
                etiqueta="Teléfono"
                [valor]="paciente.telefono"
                copiable
              />
              <app-dt-dato
                etiqueta="Teléfono alternativo"
                [valor]="paciente.telefonoAlternativo"
                copiable
              />
              <app-dt-dato etiqueta="Email" [valor]="paciente.email" copiable />
            </app-dt-datos>
          </app-dt-card>
        </div>

        <app-dt-card
          class="em-antecedentes"
          titulo="Antecedentes y observaciones"
          icono="medical_information"
        >
          @if (paciente.infoAdicional?.descripcion) {
            <p class="em-texto">{{ paciente.infoAdicional.descripcion }}</p>
          } @else {
            <span class="dt-muted">Sin antecedentes cargados</span>
          }
        </app-dt-card>
      </ng-template>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">emergency</mat-icon>
        <span>Emergencias ({{ totalEmergencias }})</span>
      </ng-template>
      <ng-template matTabContent>
        <app-tabla
          [totalCount]="totalEmergencias"
          [datos]="emergencias"
          [columnas]="columnasEmergencias"
          [name]="nameEmergencias"
          [pageSizeOptions]="helper.pageSizeOptions"
          [(query)]="queryEmergencias"
          (queryChange)="listarEmergencias()"
          [paginatorArriba]="false"
          [emptyState]="{
            title: 'Sin emergencias',
            subtitle: 'El paciente no tiene emergencias registradas.',
          }"
        ></app-tabla>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
} @else if (!loading) {
  <app-breadcrumb
    listado="/main/emergencias/destinatariosAsistencia/medica"
    etiquetaListado="Pacientes"
    [titulo]="nombre"
  ></app-breadcrumb>
  <app-empty-state
    icon="personal_injury"
    message="No se encontró el paciente"
  ></app-empty-state>
} @else {
  <app-detalle-esqueleto
    icono="personal_injury"
    listado="/main/emergencias/destinatariosAsistencia/medica"
    etiquetaListado="Pacientes"
    [pestanas]="2"
  ></app-detalle-esqueleto>
}
